<template>
  <b-modal
    :id="modalId"
    title="Создать серию"
    hide-footer
    centered
    @hidden="resetForm"
  >
    <b-form @submit.prevent="createSerie">
      <b-form-group
        label="Название серии"
        label-for="serie-name"
      >
        <b-form-input
          id="serie-name"
          v-model.trim="form.name"
          required
          placeholder="Введите название"
        />
      </b-form-group>

      <b-form-group
        label="Описание"
        label-for="serie-description"
      >
        <b-form-textarea
          id="serie-description"
          v-model.trim="form.description"
          rows="3"
          placeholder="Краткое описание серии"
        />
      </b-form-group>

      <div class="text-right mt-4">
        <b-button
          variant="secondary"
          @click="$bvModal.hide(modalId)"
        >
          Отмена
        </b-button>
        <b-button
          variant="primary"
          class="ml-2"
          type="submit"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-1"
          />
          Создать
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'DistanceModalCreateSerie',
  components: {
    BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BSpinner,
  },
  props: {
    modalId: {
      type: String,
      default: 'bv-modal-create-serie',
    },
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
      },
      loading: false,
    }
  },
  methods: {
    resetForm() {
      this.form = { name: '', description: '' }
    },
    async createSerie() {
      if (!this.form.name.trim()) {
        this.$bvToast.toast('Введите название серии', {
          title: 'Ошибка',
          variant: 'warning',
          solid: true,
        })
        return
      }

      this.loading = true
      try {
        const payload = {
          name: this.form.name,
          description: this.form.description,
          startIds: [],
        }

        await this.$http.post('start/start-series/new-serie', payload)

        this.$bvToast.toast(`Серия "${this.form.name}" успешно создана`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })

        this.$bvModal.hide(this.modalId)
        this.resetForm()
        this.$emit('serie-created')
      } catch (error) {
        console.error('Ошибка при создании серии:', error)
        this.$bvToast.toast('Ошибка при создании серии', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
